import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../supabase"; // Adjust this path to where your Supabase client is initialized
import BusinessQuestion from "./BusinessQuestion";
import NewBusinessForm from "./NewBusinessForm";
import ExistingBusinessForm from "./ExistingBusinessForm";
import OnboardingCompletion from "./OnboardingCompletion";

const Onboarding = ({ onSubmit }) => {
  const navigate = useNavigate();
  const STEPS = {
    BUSINESS_QUESTION: 1,
    NEW_BUSINESS: 2,
    EXISTING_BUSINESS: 3,
    COMPLETION: 4,
  };

  const [step, setStep] = useState(STEPS.BUSINESS_QUESTION);
  const [formData, setFormData] = useState({
    has_existing_business: null,
    business_name: "",
    business_website: "",
    business_start_date: "",
    business_age_years: null,
    platforms_used: [], // Ensure this is an array
    marketing_tools_used: [], // Ensure this is an array
    platform_profiles: {},
  });
    
  
  

  const goToStep = (targetStep) => setStep(targetStep);

  const handleCompletion = async () => {
    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();

      if (userError) {
        console.error("Error fetching user:", userError.message);
        return;
      }

      if (!user) {
        console.error("No authenticated user found.");
        return;
      }

      const { error: updateError } = await supabase
        .from("profiles")
        .update({
          is_onboarded: true,
          has_existing_business: formData.hasExistingBusiness,
          business_name: formData.businessName,
          business_website: formData.businessWebsite,
          business_start_date: formData.businessStartDate,
          business_age_years: formData.businessAgeYears,
          platforms_used: formData.platformsUsed,
          marketing_tools_used: formData.marketingToolsUsed,
          platform_profiles: formData.platformProfiles,
        })
        .eq("id", user.id);

      if (updateError) {
        console.error("Error updating profile:", updateError.message);
      } else {
        console.log("User marked as onboarded successfully!");
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("Unexpected error during onboarding completion:", err);
    }
  };

  const renderProgressBar = () => {
    const totalSteps = Object.keys(STEPS).length - 1; // Exclude completion
    const progress = (step / totalSteps) * 100;
    return (
      <div className="mb-6">
        <div className="flex justify-between mb-2">
          <span className="text-sm font-medium text-blue-600">
            Step {step} of {totalSteps}
          </span>
          <span className="text-sm font-medium text-blue-600">Onboarding</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div
            className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">
      <div className="w-full max-w-2xl p-8 bg-white rounded-lg shadow-md relative z-10">
        {step !== STEPS.COMPLETION && renderProgressBar()}

        {step === STEPS.BUSINESS_QUESTION && (
          <BusinessQuestion
            goToNewBusiness={() => goToStep(STEPS.NEW_BUSINESS)}
            goToExistingBusiness={() => goToStep(STEPS.EXISTING_BUSINESS)}
            setFormData={setFormData}
            formData={formData}
          />
        )}
        {step === STEPS.NEW_BUSINESS && (
          <NewBusinessForm
            nextStep={() => goToStep(STEPS.COMPLETION)}
            setFormData={setFormData}
            formData={formData}
            onSubmit={onSubmit}
          />
        )}
        {step === STEPS.EXISTING_BUSINESS && (
          <ExistingBusinessForm
            nextStep={() => goToStep(STEPS.COMPLETION)}
            setFormData={setFormData}
            formData={formData}
            onSubmit={onSubmit}
          />
        )}
        {step === STEPS.COMPLETION && <OnboardingCompletion onComplete={handleCompletion} />}
      </div>
    </div>
  );
};

export default Onboarding;
